import styled from 'styled-components';

import { LinkButton } from 'approot/shared/styles/buttons/link-button.style';

export const AttachLinkButton = styled(LinkButton)`
  text-align: left;
`;
